import React, { useState, useEffect } from 'react';
import { getpay } from '../apis/services';

const Pay = ({ translate }) => {
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      getpay(token)
        .then((response) => {
          console.log(response);
          setPaymentStatus(response);
        })
        .catch((error) => {
          console.error('Error fetching payment status:', error);
          setError('Error fetching payment status');
        });
    } else {
      setError('No token found');
    }
  }, []);

  return (
    <div className="content active">
      <h2>وضعیت پرداخت</h2>
      <div className="payment-section">
        {error ? (
          <p style={{ color: 'red' }}>{error}</p>
        ) : paymentStatus ? (
          <p>پرداخت شما با موفقیت انجام شد وضعیت حساب شما پس از تایید با ایمبل اطلاه رسانی میگردد</p>
        ) : (
          <p>در حال بررسی وضعیت پرداخت...</p>
        )}
      </div>
    </div>
  );
};

export default Pay; 